import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const polarisSettingsGlobalFieldsRoute: InvariantJiraRoute = {
	name: 'polaris-settings-global-fields',
	path: '/jira/settings/products/jira-product-discovery/global-fields',
	exact: true,
};
